import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";

export const Lifecycle = ({ t }) => (
  <section id="lifecycle" data-testid="section-lifecycle" className="py-32 md:py-48 border-b border-[#272A2E]">
    <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-10">
      <div className="col-span-12 lg:col-span-4">
        <Reveal><SectionHead index={t.index} title={t.title} lead={t.lead} /></Reveal>
      </div>
      <div className="col-span-12 lg:col-span-8">
        <Reveal delay={0.1}>
          <div data-testid="cost-table" className="border border-[#272A2E] bg-[#0A0B0D]">
            <table className="w-full text-left font-mono text-sm">
              <thead>
                <tr className="border-b border-[#272A2E]">
                  {t.table_head.map((h) => (
                    <th key={h} className="px-6 py-4 text-[10px] tracking-[0.2em] uppercase text-[#FF2A00] font-normal">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {t.table_rows.map((row, i) => (
                  <tr key={i} className="border-b border-[#272A2E] last:border-b-0 hover:bg-[#121417] transition-colors duration-300">
                    <td className="px-6 py-5 text-white tracking-tight">{row[0]}</td>
                    <td className="px-6 py-5 text-[#8A8F98] tracking-tight">{row[1]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-4 text-xs font-mono tracking-[0.15em] text-[#8A8F98]">{t.note}</p>
        </Reveal>
      </div>
    </div>
  </section>
);
